<template>
	<div ref="diffContainer" class="diff-container" v-html="html" @click="handleClick"></div>
</template>

<script>
/* eslint-disable camelcase */
import { diff_match_patch, DIFF_EQUAL, DIFF_DELETE, DIFF_INSERT } from 'diff-match-patch';

const HIGHLIGHT_CLASS = 'font-weight-bold';
export default {
	name: 'CodeDiff',
	props: [
		'left',
		'right',
		'diffClass'
	],
	watch: {
		left: function() {
			this.renderDiff();
		},
		right: function() {
			this.renderDiff();
		}
	},
	data: function () {
		return {
			html: '',
			countChanges: 0,
			highlightedChangeIndex: null
		}
	},
	mounted: function() {
		this.renderDiff();
	},
	methods: {
		handleClick(e) {
			let el = e.target;
			if (el.localName == 'ins' && el.attributes.pos) {
				this.$emit('insClick', {
					pos: parseInt(el.attributes.pos.nodeValue),
					value: el.innerText
				});
			} else if (el.localName == 'del' && el.attributes.pos) {
				var pos = parseInt(el.attributes.pos.nodeValue),
					value = el.innerText;
				this.$emit('delClick', {
					pos,
					value,
					len: value.length,
				});
			}
		},
		getDomElementAtIndex(index) {
			return this.$refs.diffContainer.querySelectorAll(`:scope div #diff-${index}`);
		},
		escapeHTML(html) {
			return html
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/(?:\n\r|\r\n|\n)/g, '<br/>');
		},
		renderDiff() {
			var left = this.left,
				right = this.right;
			this.countChanges = 0;
			this.highlightedChangeIndex = null;

			if (left == null && right != null) {
				this.html = `<ins>${this.escapeHTML(right)}</ins>`;
				return;
			} else if (left != null && right == null) {
				this.html = `<del>${this.escapeHTML(left)}</del>`;
				return;
			} else if (left == null && right == null) {
				this.html = '';
				return;
			}
			
			let diff = new diff_match_patch();
			let diffs = diff.diff_main(left, right);
			diff.diff_cleanupSemantic(diffs);

			this.html = '<div>';
			var i = 0;
			for (let diff of diffs) {
				var ln = diff[1].length;
				diff[1] = this.escapeHTML(diff[1]);
				
				if (diff[0] === DIFF_EQUAL) {
					this.html += `<span pos="${i}" class="equal">${diff[1]}</span>`;
				} else if (diff[0] === DIFF_DELETE) {
					this.html += `<del id="diff-${this.countChanges++}" pos="${i}" class="${this.diffClass}">${diff[1]}</del>`;
				} else if (diff[0] === DIFF_INSERT) {
					ln = 0;
					this.html += `<ins id="diff-${this.countChanges++}" pos="${i}" class="${this.diffClass}">${diff[1]}</ins>`;
				}
				
				i += ln;
			}
			this.html += '</div>';
		},
		goToIndex(index) {
			if (this.highlightedChangeIndex != null && this.highlightedChangeIndex < this.countChanges) {
				const prevElement= this.getDomElementAtIndex(this.highlightedChangeIndex);
				if (prevElement && prevElement.length > 0) {
					prevElement[0].classList.remove(HIGHLIGHT_CLASS);
				}
			}

			if (index >= this.countChanges) {
				index = 0;
			} else if (index < 0) {
				index = this.countChanges - 1;
			}
			this.highlightedChangeIndex = index;
			const element = this.getDomElementAtIndex(index);
			if (element && element.length > 0) {
				element[0].scrollIntoView();
				element[0].classList.add(HIGHLIGHT_CLASS);
			}
		},
		goToNextChange() {
			if (this.countChanges < 1) return;

			this.goToIndex(this.highlightedChangeIndex == null ? 0 : this.highlightedChangeIndex + 1);
		},
		goToPrevChange() {
			if (this.countChanges < 1) return;

			this.goToIndex(this.highlightedChangeIndex == null ? -1 : this.highlightedChangeIndex - 1);
		}
	}
}
</script>

<style>
.diff-container {
	font-family: monospace;
	font-size: 14px;
	font-variant-ligatures: contextual;
	font-weight: 400;
	line-height: 20px;
	overflow-wrap: normal;
	white-space: pre;
}

.equal{
	color: gray;
	border: 1px solid transparent;
}
ins{
	color: black;
	background: #bbffbb;
	border: 1px solid #bbffbb;
}
del{
	color: black;
	background: #ffbbbb;
	border: 1px solid #ffbbbb;
}
.merge {
	cursor: pointer;
}
.merge:hover {
	border-color: #000;
}
</style>